const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']

export function isImageUrl(url: string) {
  if (!url) return false

  const extension = url.split('.').pop()?.toLowerCase()
  if (!extension) return false
  return imageExtensions.includes(extension)
}
